import React, {FC} from 'react'

import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'

import IconMinus from 'assets/icons/delete.svg'
import MobxTextInput from 'components/elements/fields/MobxTextInput'

import s from './FieldsPayStubEarningsStatementNew.module.scss'

const cx = cn.bind(s)

export const ItemDeductions: FC<{
	store: IDeductionsStub
	isReadOnly: boolean
	removeItem: () => void
	setCustomName: (e: React.ChangeEvent<HTMLInputElement>) => void
}> = observer(({store, isReadOnly, removeItem, setCustomName}) => {
	return (
		<div className={cx('deductions__fields')}>
			{store.isCustom ? (
				<div className={cx('deductions__field')}>
					<MobxTextInput
						placeholder="Enter here"
						store={store}
						name="name"
						variant="new"
						onChange={setCustomName}
					/>
				</div>
			) : (
				<div className={cx('deductions__field')}>
					<span className={cx('normal')}>{store.name}</span>
				</div>
			)}

			<div className={cx('deductions__field')}>
				<MobxTextInput
					className={cx('ta-right')}
					placeholder="0.00"
					store={store}
					name="total"
					type="text"
					variant="new"
					isFormatText
					isNumber
					shouldHandleOldValue
					readOnly={store.isCustom || !isReadOnly ? false : true}
				/>
			</div>
			<div className={cx('deductions__field')}>
				<MobxTextInput
					variant="new"
					className={cx('ta-right')}
					placeholder="0.00"
					store={store}
					name="ytd"
					type="text"
					isFormatText
					isNumber
					shouldHandleOldValue
					readOnly={isReadOnly}
				/>
			</div>
			{store.isCustom && (
				<button
					className={cx('btn', 'btn--delete')}
					onClick={removeItem}
					type="button"
					title="Remove deductions">
					<IconMinus />
				</button>
			)}
		</div>
	)
})
